// Sample Action Types
export const SAMPLE_GET_DATA = 'SAMPLE_GET_DATA';
export const SAMPLE_GET_DATA_SUCCESS = 'SAMPLE_GET_DATA_SUCCESS';
export const SAMPLE_GET_DATA_ERROR = 'SAMPLE_GET_DATA_ERROR';
export const SAMPLE_GET_DATA_LOADING = 'SAMPLE_GET_DATA_LOADING';

export const SAMPLE_GET_API = 'SAMPLE_GET_API';
